import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { ConfigProvider } from 'antd';

import './index.css';
import 'antd/dist/antd.variable.min.css';

import App from './App';

// Approximates Frappe Desk's palette (violet-blue accent) rather than Ant's
// default blue - the one deliberate styling deviation from ScanNRead's theme.
ConfigProvider.config({
  theme: {
    primaryColor: '#5e64ff',
    infoColor: '#5e64ff',
    successColor: '#28a745',
    warningColor: '#ffc107',
    errorColor: '#dc3545',
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <ConfigProvider>
      <App />
    </ConfigProvider>
  </Router>
);
